(function(){
    'use strict';
    
    $('.searchresults .menuhead').on('click', () => {
        $('.searchresults #contentnavigation').toggleClass('filter-open');
    })
}());
